(function ($) {

    $(document).ready(function () {

        //************************************
        // anchor links
        //************************************

        let header_h = $(".header").height();

        // Click on anchor links
        $(document).on("click", ".sidebar-items a[href^='#']", function (e) {
            e.preventDefault();

            const hash = $.attr(this, "href");
            const $elem = $(hash);

            scrollToElement($elem);
            window.location.hash = hash;

            // Active class handling
            $(".sidebar-items a").removeClass("active");
            $(this).addClass("active");
        });

        // Scroll function
        function scrollToElement($elem) {
            if ($elem.length) {
                $("html, body").animate({
                    scrollTop: $elem.offset().top - header_h
                }, 700);
            }
        }

        // Scroll on page load if there's a hash in URL
        const hashFromUrl = window.location.hash;
        const decodedHash = decodeURIComponent(hashFromUrl);

        if (hashFromUrl) {
            const $elem = $(decodedHash); // використай розкодований хеш

            setTimeout(function () {
                scrollToElement($elem);

                $(".sidebar-items a").removeClass("active");
                $(".sidebar-items a[href='" + decodedHash + "']").addClass("active");
            }, 300);
        }

    });

})(jQuery);
